import privateAxiosInstance from "../utils/axios/private";
import publicAxiosInstance from "../utils/axios/public";
import { hybridEncrypt, hybridDecrypt } from "../utils/crypto";

/**
 * Candidate-related API calls
 */
export const userApi = {
    /**
     * Apply for a job or opportunity
     */
    async onboardRecruiter(payload) {
        try {
            const response = await privateAxiosInstance.post("/user/recruiter/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    /**
     * Get candidate invitations (jobs/interviews, etc.)
     */
    async listRecruiter({ page = 1, page_size = 5, pagination = "true" } = {}) {
        try {
            const response = await privateAxiosInstance.get("/user/recruiter/", { params: { page, page_size, pagination } });
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async filterListRecruiter(payload, page, page_size, pagination = "true") {
        try {
            const p = page ?? payload?.page ?? 1;
            const ps = page_size ?? payload?.page_size ?? 5;
            const pag = pagination ?? payload?.pagination ?? "true";
            const encryptedPayload = await hybridEncrypt(payload);
            const response = await privateAxiosInstance.post("/user/admin/filter/", encryptedPayload, { params: { page: p, page_size: ps, pagination: pag }, });
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async getRedirectLink(payload) {
        try {
            const response = await privateAxiosInstance.post("/user/redirect/", payload);

            let finalData = response.data;

            if (response.data?.encrypted) {
                finalData = await hybridDecrypt(response.data);
            }

            return {
                status: response.status,
                data: finalData,
                message: finalData?.message,
                success: true,
            };

        } catch (error) {

            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: null,
                    message: "NETWORK_ERROR",
                    success: false,
                };
            }

            return {
                status: error?.response?.status,
                data: error?.response?.data,
                message: error?.response?.data?.message,
                success: false,
            };
        }
    },


    async generateRecruiterPassword(payload) {
        try {
            // const encryptedPayload = await hybridEncrypt(payload);
            const response = await publicAxiosInstance.post(`/user/generate-password/`, payload);
            let finalData = response.data;
            if (response.data?.encrypted) {
                finalData = await hybridDecrypt(response.data);
            }

            return {
                status: response.status,
                data: finalData,
                message: finalData?.message,
                success: true,
            };

        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: null,
                    message: "Network error. Please check your connection.",
                    success: false,
                };
            }
            return {
                status: error?.response?.status,
                data: error?.response?.data,
                message: error?.response?.data?.message,
                success: false,
            };
        }
    },

    async validatePasswordGenerateLink(token) {
        try {
            const response = await publicAxiosInstance.get(`/user/validate/setup-link/`, { params: { token } });
            let finalData = response.data;
            if (response.data?.encrypted) {
                finalData = await hybridDecrypt(response.data);
            }

            return {
                status: response.status,
                data: finalData,
                message: finalData?.message,
                success: true,
            };

        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: null,
                    message: "Network error. Please check your connection.",
                    success: false,
                };
            }
            return {
                status: error?.response?.status,
                data: error?.response?.data,
                message: error?.response?.data?.message,
                success: false,
            };
        }
    },

    async googleLogin(payload) {

        try {

            const encryptedPayload = await hybridEncrypt(payload);

            const response = await privateAxiosInstance.post(
                "/user/google-login/",
                encryptedPayload
            );

            let finalData = response.data;

            if (response.data?.encrypted) {
                finalData = await hybridDecrypt(response.data);
            }

            return {
                status: response.status,
                data: finalData,
                message: finalData?.message,
                code: finalData?.code,
                success: true,
            };

        } catch (error) {

            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: null,
                    message:
                        "Network error. Please check your connection.",
                    success: false,
                };
            }

            return {
                status: error?.response?.status,
                data: error?.response?.data,
                message: error?.response?.data?.message,
                code: error?.response?.data?.code,
                success: false,
            };
        }
    },

async updateRecruiterEmail(payload) {
    try {
        const response = await privateAxiosInstance.put(
            "/user/recruiter/email/",
            payload
        );

        if (response.data.encrypted) {
            return await hybridDecrypt(response.data);
        }

        return response.data;
    } catch (error) {

        if (error.code === "ERR_NETWORK") {
            return {
                status: 0,
                message: "Network Error"
            };
        }

        return error.response.data;
    }
},  

};
